// import {workersInfo,workersMigration} from './request';
// import {postResource} from './../postManage/request';
// import {structureTree} from './../companyManage/request';
// import postModel from './../postManage/postModel.vue';
import userHeader from '@/components/userHeader.vue';
import moment from 'moment';
export default {
  components: {
    userHeader
  },
  data() {
    return {
      postShow: false,
      infoObj: {
        structureName: this.$t('部门1'),
        structureName2: this.$t('3748/人')
      },
      dataFrom: {
        structureId: undefined,
        postId: undefined,
        effectiveAt: '',
        reason: ''
      },
      treeData: [],
      postList: []
    };
  },
  computed: {
    dataRule() {
      return {
        structureId: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('部门')
        }],
        postId: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('岗位')
        }],
        effectiveAt: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('生效日期')
        }],
        reason: [{
          required: true,
          message: this.$t('请输入') + this.$t('原因'),
          trigger: 'blur'
        }],
        structureId2: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('上级')
        }],
        type2: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('下级迁移方式')
        }]
      };
    }
  },
  created() {
    // workersInfo({companyWorkerId:this.$route.params.id}).then(res=>{
    //   this.infoObj=res;
    //   if(res.migrateInfo.effectiveAt){
    //     this.dataFrom={
    //       structureId:res.migrateInfo.structureId,
    //       postId:res.migrateInfo.postId,
    //       effectiveAt:res.migrateInfo.effectiveAt,
    //       reason:res.migrateInfo.reason
    //     };
    //   }
    //   structureTree({customerId:res.customerId}).then(res2=>{
    //     this.treeData=res2[0].children;
    //   });
    //   this.getpostResourceFun();
    // });
  },
  methods: {
    disabledDate(current) {
      return current && current < moment().subtract(1, 'days');
    },
    getpostResourceFun(val) {
      if (val && val.companyPostId) {
        this.dataFrom.postId = val.companyPostId;
      }
      // postResource({customerId:this.infoObj.customerId}).then(res2=>{
      //   this.postList=res2;
      // });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    onChange(value) {
      this.dataFrom.structureId = value;
    },
    onSubmit() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          // let obj=this.dataFrom;
          // obj.customerId=this.infoObj.customerId;
          // obj.companyWorkerId=this.$route.params.id;
          // workersMigration(obj).then(res=>{
          this.$message.success(this.$t('操作成功'));
          this.$router.go(-1);
          // });
        }
      });
    }
  }
};